export default __webpack_public_path__ + "dc72a6f76f7a68b9d69350415fbe455f.png";